module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (85).aeb65255.jpg";